import {
	PaginationOrderHow,
	useLazyWorkplaceInsuranceExportsQuery,
	WorkplaceInsuranceExportsWhereInput,
} from '../../../graphql/graphql';
import useFlatPages from '../../Base/Hooks/useFlatPages';

export default function useInsuranceExports() {
	const [getInsuranceBatchsQuery, { data, isLoading }] =
		useLazyWorkplaceInsuranceExportsQuery();
	const { page, setPage, getNextPage } = useFlatPages();

	const getFlatInsuranceExports = (
		filter: WorkplaceInsuranceExportsWhereInput,
	) => {
		getInsuranceBatchsQuery({
			where: filter,
			pagination: {
				take: 20,
				skip: (page - 1) * 20,
				order: {
					key: 'insurance_batch.created_at',
					how: PaginationOrderHow.Desc,
				},
			},
		});
	};

	return {
		getFlatInsuranceExports,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
